import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import AttendanceSectionView from './routes/AttendanceSectionView';
import LeaveRequests from './routes/LeaveRequests';

const AttendanceDashboardLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'AttendanceDashboard' */ './components/AttendanceDashboard'
		)
);

export default (store) => {
	return [
		{
			path: 'home/attendance-dashboard',
			element: <AsyncLoading component={<AttendanceDashboardLazy />} />,
		},
		...AttendanceSectionView(),
		...LeaveRequests(store),
	];
};
